import React from "react";
import HelpButton from "../HelpContent/HelpButton";
import { FloatingLabel, Form, Row } from "react-bootstrap";
import MyIcon from "../Common/MyIcon";
import MyCollapse from "../Common/MyCollapse";
import TimezonesIcon from "../../assets/icons/timezones.svg2";
import timezones from "../Builder/nodes/Logic/timezones";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import { Warning } from "postcss";

const { countries, defaultCountry, defaultTZ } = JSON.parse(
  document.querySelector("#app").dataset.page
).props;

export default function InterfaceSetup({
  handleAccountSettingsChange,
  accountSettings,
  errors,
}) {
  return (
    <div>
      <div className="bg-purple-gradient-darker-reverse rounded-4 p-3">
        <>
          <h5 className=" d-flex align-items-center">
            <MyIcon Icon={TimezonesIcon} className="me-2" />
            <span className="ms-2">
              <span className="fw-bold me-2"> Interface Setup:</span>
              <HelpButton helpKey="settings-account-overview-interface-setup" />
              <div className="small text-secondary">
                Configure your system account settings.
              </div>
            </span>
          </h5>
          <hr className="my-3 text-secondary" />
        </>

        <Form>
          <Row>
            <div className="col-6">
              <div className="position-relative mb-2 rounded-3">
                <FloatingLabel label="System Name:">
                  <Form.Control
                    type=""
                    placeholder="System Name:"
                    name="name"
                    onChange={handleAccountSettingsChange}
                    value={accountSettings.name}
                  />
                  <div className="me-2 position-absolute top-50 end-0 translate-middle-y">
                    {" "}
                    <HelpButton helpKey="settings-interface-setup-system-name" />
                  </div>
                </FloatingLabel>
              </div>
              {accountSettings.name === "" && (
                <div className="alert alert-warning my-2 mb-4">
                  The name cannot be empty.
                </div>
              )}
            </div>
            <div className="d-flex justify-content-between gap-2">
              <div className="col-6">
                <div className=" mb-2 bg-white rounded-3 p-2">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <div>Country:</div>
                    <div className="me-2">
                      <HelpButton helpKey="settings-interface-setup-country" />
                    </div>
                  </div>
                  <Input
                    inputType="select"
                    onChange={([v]) =>
                      handleAccountSettingsChange({
                        target: { name: "country_id", value: v },
                      })
                    }
                    value={[accountSettings.country_id]}
                    options={countries.map((c) => ({
                      label: c.country_name,
                      value: c.id,
                    }))}
                  />
                </div>
                {accountSettings.country_id === "" && (
                  <div className="alert alert-warning my-2 mb-4">
                    The country cannot be empty.
                  </div>
                )}
              </div>
              <div className="col-6">
                <div className=" mb-2 bg-white rounded-3 p-2">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <div>Time Zone:</div>
                    <div className="me-2 ">
                      <HelpButton helpKey="settings-interface-setup-time-zone" />
                    </div>
                  </div>
                  <Input
                    inputType="select"
                    onChange={([v]) =>
                      handleAccountSettingsChange({
                        target: { name: "timezone", value: v },
                      })
                    }
                    value={[accountSettings.timezone]}
                    options={timezones.map((c) => ({
                      label: c.label,
                      value: c.tzCode,
                    }))}
                  />
                </div>
                {accountSettings.timezone === "" && (
                  <div className="alert alert-warning my-2 mb-4">
                    The timezone cannot be empty.
                  </div>
                )}
              </div>
            </div>
          </Row>
        </Form>
      </div>
    </div>
  );
}
